<template>
	<div id="page-content" class="supplier-sidebar">
	
		<div id="myproducts" class="component-padding">
			
			<div id="myproducts-options">
				<h1>My Products</h1>
				<div>
					<input type="text" placeholder="Search my Products"/>
					<select name="francis">
						<option value="">All Products</option>
						<option value="">Wall Sconces</option>
						<option value="">Chandeliers</option>
						<option value="">Pendants</option>
						<option value="">Undercabinet</option>
						<option value="">Ceiling</option>
						<option value="">Desk, Floor & Table Lamps</option>
						<option value="">Track</option>
						<option value="">Architectural</option>
						<option value="">Recessed</option>
					</select>
					<select name="fabrianne">
						<option value="">All Status</option>
						<option value="">Unread</option>
						<option value="">Approved</option>
						<option value="">Rejected</option>
					</select>
				</div>
				
			</div>
			
			<div class="products-list">
					<div class="col-md-4 product-item" v-for="n in 9">
						<img src="static/images/j.jpeg" />
						<p>Product Code: <strong>6SGHA14</strong></p>
						<p>Price: <strong>Php 140.00</strong></p>
						<p class="text-justify">Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.</p>
						<p>Status: Approved</p>
					</div>
			</div>
			
			<div class="cta-section-2" style="margin-top: 40px;">
				<a href="#">Load more products</a>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// SupplierProducts.vue?271c8d3c